import { render, staticRenderFns } from "./InsuranceCompanies.vue?vue&type=template&id=9c9456d6"
import script from "./InsuranceCompanies.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanies.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCompanies.vue?vue&type=style&index=0&id=9c9456d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports